<template>
    <VJoyIconButton
        data-testid="profile-experience-add"
        size="small"
        variant="ghost"
        icon="add"
        :label="$t('general.add')"
        @click="openExperiencesAddDialog"
    />
    <!-- Todo: move dialog import here, but /!\ it's also opened via AlertsSections.vue -->
</template>
<script setup lang="ts">
    import {VJoyIconButton} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';

    function openExperiencesAddDialog() {
        eventBus.emit('experiences:selection-mode');
    }
</script>
